import { checkWarranty } from '~/api/product';
import { Modal } from '~/4trend/Modal';
import { Show } from '~/components/Show';
import axios from 'axios';
import Vue from 'vue';
import { ButtonBase as Button } from '~/components/Buttons/ButtonBase';
import getBrands from '~/api/getBrands';

export const state = Vue.observable({
	showModal: false,
});

export const WarrantyModalToggle = {
	name: 'WarrantyModalToggle',
	props: {
		brandId: String,
	},
	data: () => ({
		displayButton: false,
	}),
	mounted() {
		let source = (new AbortController());

		this.$watch('brandId', (value, oldValue) => {
			this.displayButton = false;

			if (!value) return;

			source.abort();

			getBrands().then((brands) => {
				this.displayButton = brands.find((brand) => brand.ID === value)?.canVerifyWarranty || false;
			})
		}, { immediate: true });
	},
	render() {
		return (
			<div>
				<Show when={ this.displayButton }>
					<Button
						class="button button_theme_secondary-ghost"
						onClick={ () => state.showModal = true }
					>
						Проверка оригинальности
					</Button>
				</Show>
			</div>
		);
	}
}

export const WarrantyModal = {
	name: 'WarrantyModal',
	props: {
		brandId: String,
		serialNumber: String,
	},
	data: () => ({
		product: null,
	}),
	methods: {
		fetchData() {
			let { source } = this.$options

			source.abort();
			source = new AbortController();

			this.$options.source = source;

			if (!this.brandId || !this.serialNumber) {
				return;
			}

			checkWarranty(this.brandId, this.serialNumber).then((data) => {
				this.product = data.data;
				this.$refs.modal.show();
			}).catch((error) => {
				console.error(error);
			})
		},
	},
	created() {
		this.$options.source = (new AbortController());
	},
	mounted() {
		this.$refs.modal.$el.querySelector('.modal-dialog').classList.add('modal-dialog-centered');

		this.$watch(() => state.showModal, (value, valueOld) => {
			if (!value) return;

			this.fetchData();
		});
	},
	beforeDestroy() {
		this.$options.source.cancel();
	},
	render() {
		return (
			<Modal
				ref="modal"
				title="Проверка права на обслуживание и поддержку"
				onHidden={ () => {
					state.showModal = false;
					this.$emit('close');
				} }
			>
				<div>
					<Show when={ !!this.product }>
						<div>
							<Show when={ !!this.product?.image }>
								<img src={ this.product?.image } />
							</Show>
							<Show when={ !!this.product?.name }>
								<p class="m-0">
									Название: { this.product?.name }
								</p>
							</Show>
							<Show when={ !!this.product?.warranty }>
								<p class="m-0">
									Гарантия: { this.product?.warranty }
								</p>
							</Show>
							<Show when={ !!this.product?.comment }>
								<p class="m-0">
									{ this.product?.comment }
								</p>
							</Show>
						</div>
					</Show>
					<Show when={ !this.product }>
						<p class="text-danger m-0">
							К сожалению, этот серийный номер недействителен. Проверьте имеющиеся данные и повторите попытку.
						</p>
					</Show>
				</div>
			</Modal>
		);
	},
}
